import apiBase from './base';

export const getTournament = id => apiBase.get(`/tournaments/${id}`);

export const getCountries = () => apiBase.get('/countries');

export const getSports = () => apiBase.get('/admin/sports');

export const getMatchReport = id => apiBase.get(`/matches/${id}/match_report`);

export const createTournament = tournament =>
  apiBase.post('/tournaments', {
    body: { data: { tournament } },
  });

export const updateTournament = (tournamentId, tournament) =>
  apiBase.patch(`/tournaments/${tournamentId}`, {
    body: { data: { tournament } },
  });

export const createGroup = (tournamentId, group) =>
  apiBase.post(`/tournaments/${tournamentId}/groups`, {
    body: { data: { group } },
  });

export const getGroups = tournamentId => apiBase.get(`/tournaments/${tournamentId}/groups_list`);

export const deleteGroup = groupId => apiBase.delete(`/groups/${groupId}`);

export const presignUrl = image =>
  apiBase.post('/admin/presigned_url', {
    body: {
      data: { image },
    },
  });

export const generateGroupSingleMatch = (tournamentId, groupId) =>
  apiBase.post(`/tournaments/${tournamentId}/groups/${groupId}/single_match_day`);

export const generateNewMatchDays = (tournamentId, groupId, roundTrip) =>
  apiBase.post(`/tournaments/${tournamentId}/groups/${groupId}/match_days`, {
    body: {
      data: {
        match_days: {
          round_trip: roundTrip,
        },
      },
    },
  });

export const deleteMatchDay = (tournamentId, groupId, matchDayId) =>
  apiBase.delete(`/tournaments/${tournamentId}/groups/${groupId}/match_days/${matchDayId}`);

export const uploadToS3 = (response, file) => {
  const body = new FormData();

  Object.entries(response.url_fields).forEach(([key, value]) => {
    body.append(key, value);
  });

  body.append('file', file);

  return apiBase.post(response.url, {
    headers: {
      'Content-Type': null,
    },
    body,
  });
};

export const getTournaments = (page = 1) =>
  apiBase.post(`/tournaments/provider_index?page=${page}&items=9`, {
    body: {
      data: {
        q: {
          search_options: '',
          s: '',
        },
      },
    },
  });

export const generateMatches = tournamentId =>
  apiBase.post(`/tournaments/${tournamentId}/generate_match_days`);

export const getGroupMatchDays = groupId => apiBase.get(`/groups/${groupId}/match_days`);

export const scheduleMatchDay = (matchDayId, id, event) =>
  apiBase.post(`/match_days/${matchDayId}/matches/${id}/program`, {
    body: {
      data: {
        event,
      },
    },
  });

export const updateMatchDay = (matchDayId, id, event) =>
  apiBase.patch(`/match_days/${matchDayId}/matches/${id}/program`, {
    body: {
      data: {
        event,
      },
    },
  });

export const cancelMatch = (matchDayId, id, status) =>
  apiBase.patch(`/match_days/${matchDayId}/matches/${id}/status`, {
    body: {
      data: {
        status,
      },
    },
  });

export const getRoundMatchDays = roundId => apiBase.get(`/match_days/${roundId}`);

export const createMatchIncident = (matchId, incident) =>
  apiBase.post(`/matches/${matchId}/incidents`, {
    body: {
      data: {
        incident,
      },
    },
  });

export const getMatchIncidentsGoals = matchId => apiBase.get(`/matches/${matchId}/incidents_goal`);

export const getMatchIncidentsFaults = matchId =>
  apiBase.get(`/matches/${matchId}/incidents_fault`);

export const getMatchIncidentsCards = matchId => apiBase.get(`/matches/${matchId}/incidents_card`);

export const getMatchIncidentsExpulsions = matchId =>
  apiBase.get(`/matches/${matchId}/incidents_expulsion`);

export const deleteIncident = (matchId, incidentId) =>
  apiBase.delete(`/matches/${matchId}/incidents/${incidentId}`);

export const registerEventResult = (roundId, matchId, result) =>
  apiBase.post(`/match_days/${roundId}/matches/${matchId}/score_result`, {
    body: {
      data: {
        result,
      },
    },
  });

export const clearMatchResult = matchId => apiBase.patch(`/matches/${matchId}/results/clear`);

export const getPhases = () => apiBase.get(`/tournament_phases`);

export const getPositions = tournamentId => apiBase.get(`/tournaments/${tournamentId}/positions`);

export const getVolleyballPositions = tournamentId =>
  apiBase.get(`/tournaments/${tournamentId}/positions/volleyball`);

export const getVolleballMatchDetails = (groupId, matchDayId, matchId) =>
  apiBase.get(`/groups/${groupId}/match_days/${matchDayId}/matches/${matchId}/sets`);

export const updateVolleyballMatchDetails = (
  matchDayId,
  eventId,
  setId,
  clubScore,
  opponentScore,
) =>
  apiBase.patch(`/match_days/${matchDayId}/matches/${eventId}/sets/${setId}`, {
    body: {
      data: {
        event_set: {
          club_score: clubScore,
          opponent_score: opponentScore,
        },
      },
    },
  });

export const getBasketballMatchStatistics = (eventId, incident) =>
  apiBase.get(`matches/${eventId}/basketball/stats?incident_type=${incident}`);

export const getBasketballTournamentStatistics = (tournamentId, incident) =>
  apiBase.get(`tournaments/${tournamentId}/basketball/stats?incident_type=${incident}`);

export const startTournament = (tournamentId, started) =>
  apiBase.post(`/tournaments/${tournamentId}/status`, {
    body: {
      data: {
        tournament: {
          started,
        },
      },
    },
  });

export const updateSolvency = (eventId, teamId, current) =>
  apiBase.post(`/tournaments/${eventId}/participants/${teamId}/current`, {
    body: {
      data: {
        tournament: {
          current,
        },
      },
    },
  });

export const createNote = (eventId, teamId, body) =>
  apiBase.post(`/tournaments/${eventId}/participants/${teamId}/notes`, {
    body: {
      data: {
        note: { body },
      },
    },
  });

export const deleteNote = noteId => apiBase.delete(`/notes/${noteId}`);

export const updateNote = (noteId, body) =>
  apiBase.put(`/notes/${noteId}`, {
    body: {
      data: {
        note: { body },
      },
    },
  });

export const getLeaders = eventId => apiBase.get(`/tournaments/${eventId}/leaders`);

export const getCardsCount = eventId => apiBase.get(`/tournaments/${eventId}/cards_count`);
